import './styles.css';
import { getConfig } from './config/env';
import { initializeExtension } from './tableau/init';
import { getExtensionSettings } from './tableau/settings';
import { createApp } from './ui/app';
import { createAlertInspector } from './ui/alertInspector';
import { sendDebugLog } from './dev/debug';

function getMode(): string {
  const params = new URLSearchParams(window.location.search);
  return params.get('mode') ?? 'writeback';
}

async function main(): Promise<void> {
  const root = document.getElementById('app');
  if (!root) {
    console.error('App root element not found');
    return;
  }

  try {
    const config = getConfig();
    const environment = await initializeExtension();
    const settings = getExtensionSettings();
    const mode = getMode();

    void sendDebugLog('extension-initialized', {
      mode,
      dashboardName: environment.dashboardName,
      userId: environment.userId,
      configuredWorksheet: settings.worksheetName,
    });

    if (mode === 'alert-inspector') {
      createAlertInspector(environment, settings.worksheetName);
      return;
    }

    createApp(config, settings, environment);
  } catch (err) {
    console.error('Extension initialization failed:', err);
    void sendDebugLog('extension-init-failed', {
      message: err instanceof Error ? err.message : 'Unknown error',
    });

    root.innerHTML = `
      <div class="config-error">
        <p>Failed to initialize extension</p>
        <p style="font-size: 11px; margin-top: 8px; color: #666;">
          ${err instanceof Error ? err.message : 'Unknown error'}
        </p>
      </div>
    `;
  }
}

main();
